import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import exclamationCircleSVG from "images/icons/exclamation_circle.svg";

export const ExclamationCircleIcon = (props: IconProps) => {
  return <IconBase {...props} href={exclamationCircleSVG} />;
};
